const KEYWORD_DIRECTIVE_TO_FLAG = {
   'hide-product-flow': 'HideProductFlow',
   'render-components-above': 'RenderComponentsAbove',
   'render-components-below': 'RenderComponentsBelow',
}

/**
 * Reads the HtmlMetaTag with name "keywords" and parses #directives (e.g. #hide-product-flow).
 * Unknown directives are ignored. HideProductFlow defaults to false.
 * RenderComponentsAbove/Below: at least one is always true; if neither is set, RenderComponentsBelow becomes true.
 */
export function parseCategoryKeywordFlags(metaTags) {
   const keywords = metaTags?.find(t => t?.name === 'keywords')?.content ?? ''
   const flags = {
      HideProductFlow: false,
      RenderComponentsAbove: false,
      RenderComponentsBelow: false,
   }
   if (keywords) {
      const directivePattern = /#([a-zA-Z0-9-]+)/g
      let match
      while ((match = directivePattern.exec(keywords)) !== null) {
         const key = match[1].toLowerCase()
         const prop = KEYWORD_DIRECTIVE_TO_FLAG[key]
         if (prop) flags[prop] = true
      }
   }
   if (!flags.RenderComponentsAbove && !flags.RenderComponentsBelow) {
      flags.RenderComponentsBelow = true
   }
   return flags
}
